import { render } from "./student-header.vue?vue&type=template&id=59a87c6c"
import script from "./student-header.vue?vue&type=script&lang=js"
export * from "./student-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__